import Strings from "/js/util/strings.js";

/**
 * Populates text of elements in the page with localization values from `Strings`, using
 * hard-coded maps.
 *
 * Any elements created post-startup must be handled elsewhere.
 */
export default class StringsPagePopulator {

  /**
   * Map of jquery selector strings (eg, `#myElement`) to `Strings` item names
   */
  static #textNodes = {
    "#recapTitle": "generic_recap",
    "#recapReplayButton": "recap_replay_button",
    "#recapNextLessonButton": "generic_start_button",
    ".doneTitle .inner": "lesson_end_complete",
    ".doneSubtitle .inner": "lesson_end_complete_subheading",
    "#doneNextLesson .caption": "next_lesson",
    "#doneBackButton": "back_to_dashboard",
    "#recapNextLesson .caption": "next_lesson",
    "#doneNextLessonButton": "generic_start_button",
    "#doneRecapCtaButton": "lesson_end_recap_button",
    "#minicourseCompleteHeader.blueHeader": "minicourse_recap",
    "#minicourseCompleteBanner .title": "minicourse_recap_header",
    "#minicourseCompleteBanner .copy": "minicourse_recap_subheader",
    "#footer .logoLabel": "download",
    "#footerBackButton": "back_to_dashboard",
    "#footerPrivacyLink": "generic_privacy_policy",
    "#mobilePrivacy": "generic_privacy_policy",
    "#minicourseMobileDownloadCta .logoLabel": "download",
    "#recapMobileDownloadCta .logoLabel": "download",
    "#minicourseTabText": "minicourse_index",
    "#recapContent #recapTakeaways .recapSectionHeading .text": "recap_header_summary",
    "#recapContent #recapBonus .recapSectionHeading .text": "recap_header_bonus",
    "#recapContent #recapDoThisNow .recapSectionHeading .text": "recap_header_dtn"
  };

  static #ariaLabels = {
    "#nextButton": "lesson_accessibility_button_next",
    "#previousButton": "lesson_accessibility_button_previous",
    "#minicourseTab": "minicourse_index",
    "#close": "generic_close_button"
  };

  /**
   * Should be run during startup, after `Strings` has been loaded.
   */
  static populatePageStaticElements() {

    // Populate text nodes
    this.#populate(this.#textNodes, false);
    // Populate aria-label's
    this.#populate(this.#ariaLabels, true);
}

  static #populate(map, shouldPopulateAriaLabelNotTextNode) {
    for (const key in map) {
      if (!map.hasOwnProperty(key)) {
        continue;
      }
      const $el = $(key);
      if ($el.length === 0) {
        clw("WARNING: No elements found for selector", key);
      } else if ($el.length >1) {
        clw("WARNING: Multiple elements found for selector " + key +", will ignore");
      } else {
        const stringId = map[key];
        const value = Strings.get(stringId);
        if (value) {
          if (shouldPopulateAriaLabelNotTextNode) {
            $el.attr("aria-label", value);
          } else {
            $el.text(value);
          }
        }
      }
    }
  }
}
